import { render, staticRenderFns } from "./ShrinkIcon.vue?vue&type=template&id=ab9e0dba&scoped=true&"
import script from "./ShrinkIcon.vue?vue&type=script&lang=js&"
export * from "./ShrinkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9e0dba",
  null
  
)

export default component.exports